// Module
var code = "<div class=\"title-with-button\"> <h1>{{'UNAUTHORIZED' | translate }}</h1> </div> <div class=\"custom-card-box\"> <div class=\"custom-card-box-content\"> <div class=\"custom-tab-wrapper\"> <h1>{{'UNAUTHORIZED' | translate }}</h1> </div> </div> </div>";
// Exports
module.exports = code;